var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.content)?_c('article',{class:['page-content', {'border-bottom' : _vm.bordered }]},[_c('div',{staticClass:"container narrow",attrs:{"data-aos":"fade-in"},domProps:{"innerHTML":_vm._s(_vm.content.value)}})]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }